import { useEffect, useState } from 'react';

export const useImage = (fileName: string | undefined, src: string | undefined) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<any>(null);
  const [image, setImage] = useState<string | undefined>();

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const response = await import(`assets/images/${fileName}`);
        setImage(response.default);
      } catch (err: any) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fileName ? fetchImage() : setImage(src);
  }, [fileName, src]);

  return {
    loading,
    error,
    image,
  };
};
